import { useUsersContext } from 'contexts/UsersContext';

import { SectionType } from 'sections/TabWrap';
import { EditForm } from 'sections/EditForm';

import { useFormData } from './useFormData.hooks';

const useBillingAddress = () => {
  const { user, form, onSubmit } = useUsersContext();

  const formData = useFormData(form?.watch, user);

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <EditForm
          isDirty={form?.formState?.isDirty}
          onSubmit={onSubmit}
          data={formData}
          register={form?.register}
          reset={form?.reset}
          control={form?.control}
          initialValues={user}
        />
      ),
    },
  ];

  return {
    sections,
  };
};

export { useBillingAddress };
